import { SET_FILTERS_MODAL_OPEN } from 'redux/modules/cms-hybrid-recipes-page/actions/types';

export const setFiltersModalOpen = (isOpen: boolean) => ({
  type: SET_FILTERS_MODAL_OPEN,
  payload: isOpen,
});
